import { create } from 'zustand'

const TZ_KEY = 'cw_timezone'

export const useTimeZoneStore = create((set) => ({
  tz: localStorage.getItem(TZ_KEY) ?? 'UTC',
  setTz: (tz) => {
    localStorage.setItem(TZ_KEY, tz)
    set({ tz })
  },
}))
